import { graphql, useStaticQuery } from 'gatsby';

export const useGetDrupalCustomConfig = (langcode: Languages): ICustomDrupalConfig | null => {
  const data = useStaticQuery(graphql`
    query {
      allDrupalConfig {
        edges {
          node {
            langcode
            nerd_appsflyer_settings {
              onelink_domain
              smartscript_sdk_script
            }
            nerd_breed_settings {
              related_product_section_title
              tags_section_title
            }
            ln_seo_ipredirect_settings {
              text
              bt_stay
              bt_leave
            }
          }
        }
      }
    }
  `);

  const customConfig =
    data.allDrupalConfig.edges.find(
      (item: { node: ICustomDrupalConfig }) => item.node.langcode === langcode,
    ) || null;
  return customConfig?.node ?? { node: null };
};
